export default "__VITE_ASSET__D79DQJvN__"